import Markdown from 'markdown-to-jsx'
import styles from './weBelieve.module.css'

export default function WeBelieve({ data }) {
  return (
    <>
      <section className={`container-full ${styles.container}`}>
        <div className={`flex-row ${styles.content}`}>
          <div className={styles.contentText}>
            <div className={styles.title}>
              <div className={styles.parallelogramDetail} />
              <h1>{data.titulo}</h1>
            </div>
            <Markdown>{data.texto}</Markdown>
          </div>
          <img src={data.imagem.url} />
        </div>
      </section>
    </>
  )
}